import MissingEnedisNeededFields from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MissingEnedisNeededFields'
import EnedisAuth from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/EnedisAuth'
import MeterInformation from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInformation'
import MeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/MeterInput'
import useElectricityMeterListener from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeterListener'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import useElectricityMeterSave from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/useElectricityMeterSave'
import PdlSearchModal from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchModal'

const ElectricityMeter = () => {
  useElectricityMeterListener()
  const { saveElectricityMeter, isSaving, canSave, t, country } = useElectricityMeterSave()

  return (
    <>
      <MeterInput />
      <EnedisAuth />
      <MissingEnedisNeededFields />
      <MeterInformation type='client' hidden={country !== 'fr'} />
      <div>
        <SDButton
          style={{ width: '100%', marginTop: '0.5rem' }}
          disabled={!canSave}
          isLoading={isSaving}
          onClick={saveElectricityMeter}
        >
          {t('common:save')}
        </SDButton>
      </div>
      <PdlSearchModal />
    </>
  )
}

export default ElectricityMeter
